module.exports = __webpack_public_path__ + "static/mh-task1-05d97382f2c6737c94b4cdcd7a909f7e.png";